// extracted by mini-css-extract-plugin
module.exports = {"title":"_1-Pi8","noteWrapper":"_29zW7","taskWrapper":"_160Hw","getInTouchWrapper":"_2ljQe"};